import React, { useCallback, useState } from 'react';
import useVendorContext from 'contexts/vendor.context';
import TabNavigation from 'components/base/tab-navigation';
import VendorInfoTab from './vendor-info-tab';
import StoreItemsTab from './store-items-tab';
import { VENDOR_REVIEW_TABS } from './utils';

const ReviewVendorDetails = () => {
  const { vendorFormData, setVendorFormData } = useVendorContext();

  const [activeTab, setActiveTab] = useState<string>(VENDOR_REVIEW_TABS.VENDOR_INFO);
  const [editingStoreItemKey, setEditingStoreItemKey] = useState<string | null>(null);
  const [editingVendorIndex, setEditingVendorIndex] = useState<number | null>(null);

  const handleStoreItemInputChange = (
    vendorIndex: number,
    itemIndex: number,
    field: string,
    value: string
  ) => {
    const updatedVendorFormData = vendorFormData.map((vendor, vIdx) => {
      if (vIdx === vendorIndex) {
        const updatedStoreItems = vendor.store_items.map((item, iIdx) =>
          iIdx === itemIndex ? { ...item, [field]: value } : item
        );
        return { ...vendor, store_items: updatedStoreItems };
      }
      return vendor;
    });
    setVendorFormData(updatedVendorFormData);
  };

  const handleVendorInputChange = (index: number, field: string, value: string) => {
    const updatedVendorFormData = vendorFormData.map((vendor, i) =>
      i === index ? { ...vendor, [field]: value } : vendor
    );
    setVendorFormData(updatedVendorFormData);
  };

  const handleEditVendor = useCallback((index: number) => {
    setEditingVendorIndex(index);
  }, []);

  const handleSaveVendor = () => {
    setEditingVendorIndex(null);
  };

  const handleDeleteVendor = (index: number) => {
    const updatedVendorFormData = vendorFormData.filter((_, i) => i !== index);
    setVendorFormData(updatedVendorFormData);
  };

  const handleEditStoreItem = (vendorIndex: number, itemIndex: number) => {
    setEditingStoreItemKey(`${vendorIndex}-${itemIndex}`);
  };

  const handleSaveStoreItem = () => {
    setEditingStoreItemKey(null);
  };

  const handleDeleteStoreItem = (vendorIndex: number, itemIndex: number) => {
    const updatedVendorFormData = vendorFormData.map((vendor, vIdx) => {
      if (vIdx === vendorIndex) {
        const updatedStoreItems = vendor.store_items.filter((_, iIdx) => iIdx !== itemIndex);
        return { ...vendor, store_items: updatedStoreItems };
      }
      return vendor;
    });
    setVendorFormData(updatedVendorFormData);
  };

  const handleAddStoreItemToVendor = (vendorIndex: number, ingredientId: string) => {
    const updatedVendorFormData = vendorFormData.map((vendor, vIdx) => {
      if (vIdx === vendorIndex) {
        return {
          ...vendor,
          store_items: [{ ingredient_id: ingredientId, gram_price: '' }]
        };
      }
      return vendor;
    });
    setVendorFormData(updatedVendorFormData);
  };

  const tabs = [
    { label: 'Vendor Details', value: VENDOR_REVIEW_TABS.VENDOR_INFO },
    { label: 'Vendor Store Items', value: VENDOR_REVIEW_TABS.STORE_ITEMS }
  ];

  return (
    <div>
      <TabNavigation tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === VENDOR_REVIEW_TABS.VENDOR_INFO && (
        <VendorInfoTab
          editingVendorIndex={editingVendorIndex}
          onVendorInputChange={handleVendorInputChange}
          onEditVendor={handleEditVendor}
          onSaveVendor={handleSaveVendor}
          onDeleteVendor={handleDeleteVendor}
        />
      )}

      {activeTab === VENDOR_REVIEW_TABS.STORE_ITEMS && (
        <StoreItemsTab
          editingStoreItemKey={editingStoreItemKey}
          onStoreItemInputChange={handleStoreItemInputChange}
          onEditStoreItem={handleEditStoreItem}
          onSaveStoreItem={handleSaveStoreItem}
          onDeleteStoreItem={handleDeleteStoreItem}
          onAddStoreItemToVendor={handleAddStoreItemToVendor}
        />
      )}
    </div>
  );
};

export default ReviewVendorDetails;
